"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";
import "./pin.css"; // Link to your CSS file

export const PinContainer = ({ children, title, href, className, containerClassName }) => {
  const [transform, setTransform] = useState("translate(-50%,-50%) rotateX(0deg)");

  const onMouseEnter = () => {
    setTransform("translate(-50%,-50%) rotateX(40deg) scale(0.8)");
  };

  const onMouseLeave = () => {
    setTransform("translate(-50%,-50%) rotateX(0deg) scale(1)");
  };

  return (
    <div
      className={`pin-container ${containerClassName}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div
        style={{ perspective: "1000px", transform: "rotateX(70deg) translateZ(0deg)" }}
        className="pin-perspective-wrapper"
      >
        <div
          style={{ transform: transform }}
          className="pin-content-container"
        >  
         <div className="gotcha" >
         <div className={className}>{children}</div>
         </div>
          
        </div>
      </div>
      <PinPerspective title={title} href={href} />
    </div>
  );
};

export const PinPerspective = ({ title, href }) => {
  return (
    <motion.div className="pin-hover-content">
      <div className="pin-hover-wrapper">
        <a href={href} target="_blank" className="pin-link">
          <span className="pin-link-text">{title}</span>
          <span className="pin-link-underline"></span>
        </a>
      </div>
      <div
        style={{ perspective: "1000px", transform: "rotateX(70deg) translateZ(0)" }}
        className="pin-animation-container"
      >
        <motion.div className="pin-animation-circle"></motion.div>
        <motion.div className="pin-animation-circle"></motion.div>
        <motion.div className="pin-animation-circle"></motion.div>
      </div>
      <motion.div className="pin-hover-effects"></motion.div>
      <motion.div className="pin-hover-effects"></motion.div>
      <motion.div className="pin-hover-effects"></motion.div>
      <motion.div className="pin-hover-effects-small"></motion.div>
    </motion.div>
  );
};
